(function () {
  if (window.__addOnGuideVideoInit) return;
  window.__addOnGuideVideoInit = true;

  function getEmbedFromTarget(target) {
    if (!target || !target.closest) return null;
    var fromPlay = target.closest("[data-guide-video-play]");
    if (fromPlay) {
      var block = fromPlay.closest(".add-on-guide-modal__video-block");
      if (!block) return null;
      return block.querySelector(
        ".add-on-guide-modal__video-embed--has-cover"
      );
    }
    var cover = target.closest(".add-on-guide-modal__video-cover");
    if (cover) {
      return cover.closest(
        ".add-on-guide-modal__video-embed--has-cover"
      );
    }
    return null;
  }

  function startPlayback(embed) {
    if (!embed || embed.getAttribute("data-guide-has-cover") !== "true")
      return;
    if (embed.getAttribute("data-guide-playing") === "true") return;
    var video = embed.querySelector("video.add-on-guide-modal__video-el");
    embed.setAttribute("data-guide-playing", "true");
    if (video) {
      var p = video.play();
      if (p && typeof p.then === "function")
        p.catch(function () {});
    }
  }

  document.addEventListener("click", function (e) {
    var stickyClose = e.target.closest(".add-on-guide-modal__mobile-sticky-close");
    if (stickyClose) {
      e.preventDefault();
      var modalRoot = stickyClose.closest("[data-modal]");
      var nativeClose = modalRoot && modalRoot.querySelector(".modal__header [data-modal-close]");
      if (nativeClose) nativeClose.click();
      return;
    }

    var embed = getEmbedFromTarget(e.target);
    if (embed) {
      e.preventDefault();
      startPlayback(embed);
    }
  });
})();
